let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("2rSfW")).then(() => parcelRequire('93A4c'));